"use strict";
module.exports = require("../lib/Rectangle.art");
